(()=>{
  const ready=()=>{
    document.querySelectorAll('[data-luma-gallery]:not([data-luma-ready])').forEach(gallery=>{
      gallery.dataset.lumaReady='true';
      const track=gallery.querySelector('[data-luma-gallery-track]');
      const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
      const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
      thumbs.forEach(button=>button.addEventListener('click',()=>{
        const slide=slides[Number(button.dataset.galleryThumb)];
        if(slide) track.scrollTo({left:slide.offsetLeft,behavior:'smooth'});
      }));
      if(track&&slides.length>1){
        let raf;
        track.addEventListener('scroll',()=>{
          cancelAnimationFrame(raf);
          raf=requestAnimationFrame(()=>{
            const current=slides.reduce((best,slide,index)=>Math.abs(track.scrollLeft-slide.offsetLeft)<best.distance?{index,distance:Math.abs(track.scrollLeft-slide.offsetLeft)}:best,{index:0,distance:Infinity}).index;
            thumbs.forEach((thumb,index)=>thumb.classList.toggle('is-active',index===current));
          });
        },{passive:true});
      }
    });

    document.querySelectorAll('[data-luma-carousel]:not([data-luma-ready])').forEach(carousel=>{
      carousel.dataset.lumaReady='true';
      const track=carousel.querySelector('[data-carousel-track]');
      if(!track)return;
      const move=direction=>track.scrollBy({left:track.clientWidth*.82*direction,behavior:'smooth'});
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>move(-1));
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click',()=>move(1));
    });

    document.querySelectorAll('[data-luma-product-main]:not([data-luma-form-ready])').forEach(section=>{
      section.dataset.lumaFormReady='true';
      const form=section.querySelector('[data-luma-product-form]');
      if(!form)return;
      form.addEventListener('submit',async event=>{
        const upsell=form.parentElement.querySelector('[data-luma-upsell]:checked');
        const upsellId=upsell?.dataset.upsellVariant;
        if(!upsellId)return;
        event.preventDefault();
        const mainId=new FormData(form).get('id');
        const button=form.querySelector('[type="submit"]');
        if(!mainId)return;
        button?.setAttribute('disabled','disabled');
        try{
          const root=window.Shopify?.routes?.root||'/';
          const response=await fetch(`${root}cart/add.js`,{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(mainId),quantity:1},{id:Number(upsellId),quantity:1}]})
          });
          if(!response.ok)throw new Error('No fue posible agregar la colección y el render al carrito.');
          window.location.href=`${root}cart`;
        }catch(error){
          button?.removeAttribute('disabled');
          window.alert(error.message);
        }
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
  document.addEventListener('shopify:section:load',ready);
})();
